// `https://2e3688df1e504fc3a3984e033bb4612c@sentry-dev.prismacloud.cc/16` gets replaced during buildtime by envsubst
export const BUILD_SENTRY_DSN = 'https://2e3688df1e504fc3a3984e033bb4612c@sentry-dev.prismacloud.cc/16'.includes('SENTRY_DSN')
  ? ''
  : 'https://2e3688df1e504fc3a3984e033bb4612c@sentry-dev.prismacloud.cc/16';
